import { date } from 'quasar'
import lk from 'src/utils/lk'

export default {
  jobList,
  rosterStatusOptions,
  approvalStatusOptions,
}

function setStatus(status) {
  switch (status) {
    case 1: return 'Processing'
    case 2: return 'Ready for Review'
    case 5: return 'In Review'
    case 3: return 'Completed'
    case 4: default: return 'Error'
  }
}

function getApprovalStatus(approvalStatusId) {
  for (let key in lk.LK_CLASS_APPROVAL_STATUS_ID) {
    if (lk.LK_CLASS_APPROVAL_STATUS_ID[key] === approvalStatusId) {
      return key
    }
  }
  return null
}

function jobList(state, getters, rootState) {
  return state.list.map(e => ({
    ...e,
    DATE_CREATED: date.formatDate(e.DATE_CREATED, rootState.shared.formats.datetime),
    statusText: setStatus(e.ROSTER_JOB_STATUS),
    approvalStatus: e.CLASS ? getApprovalStatus(e.CLASS.LK_CLASS_APPROVAL_STATUS_ID) : null
  }))
}

function rosterStatusOptions(state) {
  return state.rosterJobStatuses
}

function approvalStatusOptions(state) {
  return state.approvalStatuses
}